import { LIST_REQUIRED_STATUSES } from "../../required-values";

export default {
    MISSING_EMAIL_FIELD_ERROR: {
        TITLE: 'Missing field for Email Address',
        MESSAGE: 'Please add at least 1 field for email address!'
    },
    INVALID_INPUT_ERROR: {
        TITLE: 'A required field is missing or a field is invalid.',
        MESSAGE: 'Please review the form for error messages!'
    },
    MISSING_BOOKING_TIME_ERROR: {
        TITLE: 'Booking time is missing',
        MESSAGE: 'Please add booking time (Start Time and End Time)!'
    },
    MISSING_SIGNATURE_ERROR: {
        TITLE: 'A document is not signed',
        MESSAGE: 'Please review the form for error messages and sign all documents!'
    },
    INPUT_CONDITION_ERROR: {
        TITLE: 'An input field is invalid',
        MESSAGE: 'There is an input field which is invalid'
    },
    BUILDER_NO_FIELD_ERROR: {
        TITLE: 'There is no field for the builder',
        MESSAGE: 'Please add at least one field!'
    },
    EXCLUSIVE_OPTIONS_USE_SAME_VALUE: {
        TITLE: 'Cannot use same option between {0} and {1}',
        MESSAGE: 'Please unselect option(s) {2} in {0} or {1}'
    },
    MISSING_DEPENDENCY_OBJECT_ERROR: {
        TITLE: 'Please add more {0}!',
        MESSAGE: 'You must have at least {1} {0}'
    },
    MISSING_EXPERIENCE_ERROR: {
        TITLE: 'Experience is lacking',
        MESSAGE: 'You must have at least 1 experience.'
    },
    MISSING_STATUS_ERROR: {
        TITLE: 'Statuses is lacking',
        MESSAGE: `${LIST_REQUIRED_STATUSES.join(" and ")} are required statuses`
    },
    DUPLICATE_STATUS_ERROR: {
        TITLE: 'Statuses is duplicated',
        MESSAGE: 'There are some statuses which are duplicated'
    },
    DUPLICATE_MODEL_ERROR: {
        TITLE: 'Multi fields using the same model',
        MESSAGE: 'There is a model which is assigned to at least 2 fields'
    },
    DUPLICATE_CHECKLIST_ITEM_ERROR: {
        TITLE: 'Statuses is duplicated',
        MESSAGE: 'There are some items which are duplicated'
    },
    DUPLICATE_EMPLOYER_TYPE_ERROR: {
        TITLE: 'Employer type is duplicated',
        MESSAGE: 'There are some employer type which are duplicated'
    },
    DUPLICATE_CANDIDATE_TYPE_ERROR: {
        TITLE: 'Candidate type is duplicated',
        MESSAGE: 'There are some candidate type which are duplicated'
    },
    INVALID_IMAGE_FILE_TYPE_ERROR: {
        TITLE: 'Sorry, that file type is invalid!',
        MESSAGE: 'Please upload a PNG or JPG image.'
    },
    INVALID_DOC_FILE_TYPE_ERROR: {
        TITLE: 'Sorry, that file type is invalid!',
        MESSAGE: 'Please upload a DOC or DOCX or PDF file.'
    },
    EMPTY_FILE_ERROR: {
        TITLE: 'File is empty!',
        MESSAGE: 'Please upload a non empty file'
    },
    FILE_SIZE_EXCEED_LIMIT_ERROR: {
        TITLE: 'File too big!',
        MESSAGE: 'Please upload a file with a size below the maximum upload size.'
    },
    INVALID_INPUT_FILE: {
        TITLE: 'Invalid File',
        MESSAGE: 'Invalid input file'
    },
    MISSING_RESUME_ERROR: {
        TITLE: 'Your professional childcare resume is missing',
        MESSAGE: 'Please upload your professional childcare resume'
    },
    END_DATE_BEFORE_START_DATE_ERROR: {
        TITLE: 'End date must be after start date',
        MESSAGE: 'Please change start date or end date'
    },
    END_HOUR_BEFORE_START_HOUR_ERROR: {
        TITLE: 'End time must be after start time',
        MESSAGE: 'Please change start time or end time'
    },
    BOOKING_DURATION_TOO_SHORT_ERROR: {
        TITLE: 'Bookings must be at least {0} hours.',
        MESSAGE: 'Please change start time or end time'
    },
    MISSING_PROFILE_PICTURE_ERROR: {
        TITLE: 'Your profile picture is missing',
        MESSAGE: 'Please upload a recent photo of yourself!'
    },
    NO_TEXT_SELECT: {
        TITLE: 'No text selected',
        MESSAGE: 'Please select some text'
    },
    SUBMIT_REFERENCE_ERROR: {
        TITLE: 'Your application has been submitted! BUT',
        MESSAGE: 'There was an error processing your references. Can you please email them to us? Thanks!'
    },
    SUBMIT_ERROR: {
        TITLE: 'Failed to submit your application',
        MESSAGE: 'There was an error processing your application'
    },
    MISSING_ITEM_IN_JOB_STATUS_LIST: {
        TITLE: 'Missing item in status list',
        MESSAGE: 'Status {0} is required'
    },
    HAS_INCOMPLETE_SECTION: {
        TITLE: 'There is an incomplete section',
        MESSAGE: 'Section {0} is incomplete. Please update that section'
    },
    PASSWORD_UNMATCH_ERROR: {
        TITLE: 'Passwords do not match.'
    },
    MISSING_ADDRESS_ERROR_DIALOG: {
        TITLE: 'Unable to find nearby Candidates',
        MESSAGE: 'Job is missing a full address. To search for candidates Edit Job and fill missing address info'
    },
    PROFILE_BUILDER_IN_USED: {
        TITLE: 'The profile builder is in used',
        MESSAGE: 'The profile builder is being used by the profile builder {0}.\n' +
            'Please remove that profile builder first'
    },
    MISSING_SIGNATURE_ERROR_DIALOG: {
        TITLE: 'A signature is missing',
        MESSAGE: 'Please type your name to sign'
    },
    MISSING_REQUIRED_FIELD_SIGNING_ERROR_DIALOG: {
        TITLE: 'A required field is missing',
        MESSAGE: 'Please fill all of the required fields (Please check the red border fields)'
    },
    USER_EXISTED_ERROR_DIALOG: {
        INNER_HTML: `
        <h2>It looks like you are already in our system!</h2>
        <h4 class="error-message main-message">
        Please <a href='{0}/login/{1}'>log into your dashboard</a> to continue, or contact us if you have questions. Thank you!
        </h4>
        `
    }
}


// WEBPACK FOOTER //
// ./src/constants/multi-languages/error-dialog/de.js